import { motion } from "framer-motion";
import { Gift, Sparkles, CalendarDays } from "lucide-react";

const FEATURES = [
  {
    icon: Gift,
    title: "Récompenses",
    description: "Plus tu prends soin de toi, plus tu gagnes des récompenses.",
    testid: "feature-rewards",
  },
  {
    icon: Sparkles,
    title: "Programme personnalisé",
    description: "Choisis les outils qui te plaisent pour transformer ton mental.",
    testid: "feature-program",
  },
  {
    icon: CalendarDays,
    title: "Plan de 60 jours",
    description: "En moyenne, le glow up mental se ressent au bout de 60 jours.",
    testid: "feature-plan",
  },
];

export default function Features() {
  return (
    <section
      data-testid="features-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mx-auto text-center mb-16 sm:mb-20"
        >
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#B47CE8] font-semibold mb-4">
            Fonctionnalités
          </span>
          <h2
            data-testid="features-title"
            className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-white leading-[1.05]"
          >
            Comment Echo t&apos;aide à{" "}
            <span className="bg-gradient-to-br from-[#E9D5FF] to-[#9D4CDD] bg-clip-text text-transparent">
              glow up mentalement
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {FEATURES.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <motion.article
                key={feature.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                data-testid={feature.testid}
                className="group relative rounded-[32px] glass p-8 sm:p-10 hover:border-white/20 hover:bg-white/[0.05] hover:-translate-y-1 transition-all duration-500"
              >
                <div className="absolute -top-px left-8 right-8 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#9D4CDD]/30 to-[#6D28D9]/20 border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-transform duration-500 shadow-[0_0_30px_rgba(157,76,221,0.15)]">
                  <Icon className="w-7 h-7 text-white" strokeWidth={1.8} />
                </div>

                <h3 className="text-2xl font-bold text-white mb-3 tracking-tight">
                  {feature.title}
                </h3>
                <p className="text-white/60 leading-relaxed font-medium">
                  {feature.description}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
